export const routes = {
  inbox: {
    list: "/inbox",
    agentView: "/agent",
    agentViewDetail: "/agent/:agentId",
  },
  users: {
    list: "/users",
    detail: "/users/:userId",
  },
  earnings: {
    list: "/earnings",
    detail: "/earnings/:userId",
    summary: "/earnings/:userId/summary",
  },
  artist: {
    list: "/artists",
    detail: "/artists/:artistId",
    earnings: "/artists/:artistId/earnings",
    notes: "/artists/:artistId/notes",
  },
  releases: {
    list: "/releases",
    detail: "/releases/:id",
    // detail: ':id',
    generalData: "general",
    trackData: "track/:trackId",
    messages: "messages",
    changelog: "changelog",
    notes: "notes",
  },
  syncLicense: {
    syncBriefs: "/sync-briefs",
  },
};
